import { useState } from 'react';
import axios from 'axios';
import { apiKey, apiUrl } from '../lib/config';

export const useApiPatch = (url, token = null) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [responseData, setResponseData] = useState(null);

  const patchData = async (payload) => {
    setLoading(true);
    setError(null);

    try {
      const isFormData = payload instanceof FormData;
      const headers = {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(apiKey && { 'x-api-key': apiKey }),
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      };

      const fullUrl = `${apiUrl}${url}`;
      const response = await axios.patch(fullUrl, payload, { headers });

      setResponseData(response.data);
      return { result: response.data, error: null };
    } catch (err) {
      let errorMsg = "Something went wrong";
      let errorResMsg = err?.response?.data?.message;
      let defaultMsg = err?.message;

      if (errorResMsg) {
        errorMsg = errorResMsg;
      } else if (defaultMsg) {
        errorMsg = defaultMsg;
      }

      setError(errorMsg);
      return { result: null, error: errorMsg };
    } finally {
      setLoading(false);
    }
  };

  return { patchData, loading, error, responseData };
};
